export const initialState={
    User:null
};

export const reducer=(state,action)=>{
   switch(action.type){
       case "PERSONAL_DETAIL":return {
          User:{
           ...state.User,
           Personal:{
            ...state.User?.Personal,
            ...action.payload
           }
          }
       };
       case "EDUCATION_DETAIL":return {
          User:{
           ...state.User,
           Education:{
            ...state.User?.Education,
            ...action.payload
           }
          }
       };
       case "SKILLS":return {
          User:{
           ...state.User,
           Skills:{
            ...state.User?.Skills,
            ...action.payload
           }
          }
       };
       case "PROJECTS_DETAIL":return {
          User:{
           ...state.User,
           Projects:{
            ...state.User?.Projects,
            ...action.payload
           }
          }
       };
       
       case "OBJECTIVE_DETAIL":return {
          User:{
           ...state.User,
           Objective:action.payload.Objective
          }
       };

       default: return state;
       
   }
    
   
}